/* eslint no-use-before-define: 0 */

import React from 'react';
import FormattedPrice from './FormattedPrice';
import './payButton.scss';

function PayButton({price, text, onClick, disabled}) {
  const onButtonClick = () => {
    if (disabled) {
      return;
    }

    onClick();
  };

  return (
    <div className={ `btn pay-btn ${disabled ? 'disabled' : ''}` } onClick={ onButtonClick }>
      <div className="pay-text">{text}</div>
      <div className="price-block">
        <FormattedPrice price={ price } />
      </div>
    </div>
  );
}

export default PayButton;
